var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgSeoOk = function SvgSvgSeoOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3aa648",
    d: "M9.325 17.916q-.176 0-.352-.035a1.8 1.8 0 0 1-1.146-.764l-2.44-3.462a.75.75 0 0 1 1.227-.864l2.45 3.477a.3.3 0 0 0 .26.148.3.3 0 0 0 .237-.119l7.852-9.935a.75.75 0 0 1 1.175.93l-7.843 9.923a1.8 1.8 0 0 1-.423.396 1.8 1.8 0 0 1-.997.305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3aa648",
    d: "M12 23.999c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12m0-22.5c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5"
  })));
};
export default SvgSvgSeoOk;